var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80752 4.08706V6.15795L5.55762 7.903V4.08704C5.55762 3.88356 5.83728 3.71875 6.18257 3.71875C6.52786 3.71875 6.80752 3.88358 6.80752 4.08706Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51572 23.7506V20.3136L7.76562 19.3844V23.7506C7.76562 24.0157 7.48597 24.2305 7.14067 24.2305C6.79538 24.2305 6.51572 24.0157 6.51572 23.7506Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7031 23.5849V20.8133C13.286 20.8923 12.8313 20.8622 12.4532 20.7305V23.5848C12.4532 23.7928 12.7329 23.9612 13.0782 23.9612C13.4235 23.9612 13.7031 23.7928 13.7031 23.5849Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5322 0.43259V3.62344C13.1151 3.53246 12.6604 3.56712 12.2823 3.71875V0.432658C12.2823 0.19329 12.562 -0.000579119 12.9073 -0.000579119C13.2526 -0.000579119 13.5322 0.193221 13.5322 0.43259Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6514 21.8941V18.8631L19.9013 18.0938V21.8941C19.9013 22.0256 19.6216 22.1321 19.2763 22.1321C18.931 22.1321 18.6514 22.0256 18.6514 21.8941Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.229 3.48661V6.05687L20.4789 7.16016V3.48661C20.4789 3.36548 20.1992 3.26737 19.854 3.26737C19.5087 3.26737 19.229 3.36548 19.229 3.48661Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.918 8.43686V19.0357C23.918 19.0357 23.9973 19.793 24.5429 19.793C25.0886 19.793 25.1679 19.0357 25.1679 19.0357V8.43686C25.1679 8.01753 24.8882 7.67791 24.5429 7.67791C24.1976 7.67791 23.918 8.01753 23.918 8.43686Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94948 20.4543L2.96817 19.4997V17.7619C2.96817 17.4381 2.68851 17.1758 2.34321 17.1758C1.99792 17.1758 1.71826 17.4381 1.71826 17.7619V20.3224L1.94948 20.4543Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05127 23.7885L1.80137 24.6889V24.7315C1.80137 24.8141 2.08102 25 2.42632 25C2.77161 25 3.05127 24.8141 3.05127 24.7315V24.1968V23.7885Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.176 17.8083C16.7799 19.1973 14.9095 20.0065 12.9411 20.0715C10.9727 20.1355 9.05334 19.4522 7.56891 18.158L1.9407 23.793C1.83946 23.9018 1.69456 23.97 1.54748 23.9732C1.40254 23.9742 1.26655 23.913 1.16318 23.8118C1.06087 23.7084 1.00023 23.5718 1.00023 23.4257C1.00023 23.2797 1.05912 23.1408 1.16143 23.0374L6.81542 17.4041C5.48327 15.8691 4.80441 13.8744 4.92483 11.8448C5.04419 9.81613 5.95218 7.91442 7.4559 6.54663C8.95856 5.17785 10.9377 4.45293 12.9678 4.52435C14.999 4.59684 16.9204 5.46139 18.323 6.93145C19.7255 8.40257 20.4971 10.364 20.4726 12.3969C20.4481 14.4288 19.6296 16.3709 18.1919 17.8081L18.176 17.8083ZM17.4013 7.56893C15.7132 5.87288 13.2481 5.20552 10.9356 5.82065C8.62192 6.43468 6.81242 8.23629 6.18793 10.5463C5.5634 12.8574 6.21883 15.3265 7.90693 17.0223C9.59504 18.7181 12.0601 19.3857 14.3726 18.7717C16.6852 18.1576 18.4947 16.355 19.1192 14.045C19.7448 11.7338 19.0894 9.26585 17.4013 7.56893Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLine);
export default __webpack_public_path__ + "static/media/searchLine.4276875c535a47bd954d86b4271e4819.svg";
export { ForwardRef as ReactComponent };